import { usePrevious, useSize } from 'ahooks';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Chips from './chips';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ChipsNumber = props => {
  var _useSize$width, _useSize, _input$value$toString, _input$value;
  const {
    active,
    input,
    extra,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-chipsNumber");
  const inputRef = useRef(null);
  const unitRef = useRef(null);
  const unitWidth = (_useSize$width = (_useSize = useSize(unitRef)) === null || _useSize === void 0 ? void 0 : _useSize.width) !== null && _useSize$width !== void 0 ? _useSize$width : 0;
  const preActive = usePrevious(active);
  const [inputVal, setInputVal] = useState((_input$value$toString = input === null || input === void 0 || (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.toString()) !== null && _input$value$toString !== void 0 ? _input$value$toString : '');
  const onInput = v => {
    const reg = new RegExp(input !== null && input !== void 0 && input.precision ? "^[0-9]+.?[0-9]{0,".concat(input.precision, "}$") : '^[0-9]+$');
    if (v === '' || reg.test(v)) {
      var _input$onChange;
      setInputVal(v);
      input === null || input === void 0 || (_input$onChange = input.onChange) === null || _input$onChange === void 0 || _input$onChange.call(input, v ? Number(v) : undefined);
    }
  };
  useEffect(() => {
    var _input$value$toString2, _input$value2;
    const v = (_input$value$toString2 = input === null || input === void 0 || (_input$value2 = input.value) === null || _input$value2 === void 0 ? void 0 : _input$value2.toString()) !== null && _input$value$toString2 !== void 0 ? _input$value$toString2 : '';
    if (v ? Number(v) !== Number(inputVal) : inputVal !== '') {
      setInputVal(v);
    }
  }, [input === null || input === void 0 ? void 0 : input.value]);
  useEffect(() => {
    if (active && !preActive && !(input !== null && input !== void 0 && input.readOnly)) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }
  }, [active]);
  return /*#__PURE__*/_jsx(Chips, {
    ...restProps,
    active: active,
    className: classNames(baseClassName, className),
    style: {
      ...style,
      width: 240,
      height: 72
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--inner"),
      children: [/*#__PURE__*/_jsxs("div", {
        className: "number-row",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "number-row--input",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "input-mirror",
            children: [/*#__PURE__*/_jsx("div", {
              className: "input-mirror--value",
              style: {
                maxWidth: "calc(100% - ".concat(unitWidth, "px)")
              },
              children: inputVal
            }), /*#__PURE__*/_jsx("div", {
              ref: unitRef,
              className: "input-mirror--unit",
              children: !!inputVal && (input === null || input === void 0 ? void 0 : input.unit)
            })]
          }), /*#__PURE__*/_jsx("input", {
            ref: inputRef,
            placeholder: input === null || input === void 0 ? void 0 : input.placeholder,
            readOnly: input === null || input === void 0 ? void 0 : input.readOnly,
            value: inputVal,
            style: {
              paddingRight: unitWidth
            },
            onBlur: () => {
              if (inputVal) {
                setInputVal(Number(inputVal).toString());
              }
            },
            onChange: e => {
              onInput(e.target.value);
            }
          })]
        }), !!extra && /*#__PURE__*/_jsx("div", {
          className: "number-row--extra",
          children: extra
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "children-row",
        children: children
      })]
    })
  });
};
export default ChipsNumber;